import { QueryFunctionContext } from '@tanstack/react-query';

import { GET_IMAGE, GET_WITH_CREDENTIALS } from '~/api';
import { ValidateUrl } from '~/api/urls';

export const getVehicleImage = async (context: QueryFunctionContext<[string], { signal?: boolean | AbortSignal }>) => {
  const [src] = context.queryKey;
  const { signal } = context.meta || {};

  const options: RequestInit = { signal: signal === true ? context.signal : signal ? signal as AbortSignal : undefined }

  return GET_IMAGE(src, options);
}

export const validateVehicleImages = async ({ vehicle, year}: { vehicle: string, year: string}): Promise<string[] | undefined> => {
  const url = ValidateUrl.expand({ vehicle, year});

  return GET_WITH_CREDENTIALS<string[]>(url);
}
